import React, {FC} from 'react';
import {Link} from 'react-router-dom';
import classNames from 'classnames';

import {Icon} from 'components/baseIcon/baseIcon';
import * as OttotoIcon from 'components/__helpers/icon/svg/brands/ottoto.svg';
import * as CostaIcon from 'components/__helpers/icon/svg/brands/costaDelMar.svg';
import * as MuseAndHilaryDuffIcon from 'components/__helpers/icon/svg/brands/museAndHilaryDuff.svg';
import * as VersaceIcon from 'components/__helpers/icon/svg/brands/versace.svg';
import * as MichaelKorsIcon from 'components/__helpers/icon/svg/brands/michaelKors.svg';
import * as CoachIcon from 'components/__helpers/icon/svg/brands/coach.svg';
import * as MuseIcon from 'components/__helpers/icon/svg/brands/muse.svg';
import * as OakleyIcon from 'components/__helpers/icon/svg/brands/oakley.svg';
import * as RayBanIcon from 'components/__helpers/icon/svg/brands/rayBan.svg';
import {MenuArrowIcon} from 'features/menu/helpers/icons/menuArrow/menuArrow';

import s from './brandLink.scss';

const ICONS = {
    ottoto: OttotoIcon,
    costa: CostaIcon,
    museAndHilaryDuff: MuseAndHilaryDuffIcon,
    versace: VersaceIcon,
    michaelKors: MichaelKorsIcon,
    coach: CoachIcon,
    muse: MuseIcon,
    oakley: OakleyIcon,
    rayBan: RayBanIcon,
};

type PropsType = {
    to: string;
    brandName: string;
    onClick?: () => void;
};

/**
 *  Functional-component for BrandLink
 *  @param {PropsType} props - Received props
 *  @returns {Node} - Rendered BrandLink stateless component
 */
export const BrandLink: FC<PropsType> = ({to, brandName, onClick}) => (
    <Link to={to} className={s.link} aria-label={brandName} onClick={onClick} role="menuitem">
        <div className={classNames(s[brandName], s.brand)}>
            <Icon icon={ICONS[brandName]} role="presentation" />
        </div>
        <MenuArrowIcon className={s.arrow} />
    </Link>
);
